/**
 * DOCU: Contains Useful Static Functions
 * Author: Arjhay Frias
 * Contact: arjhay.frias@thecollective.ph
 * Created At: 05-11-2023
 * Updated At: 05-12-2023
 */
class Functions {
  constructor() {
    this.is_buffer_open = false;
    this.buffer_timer;
    this.current_height;
  }

  /**
   * DOCU: Get Current Path Name
   * @returns {string}
   */
  static getCurrentPath() {
    return window.location.pathname.split('/')[1];
  }

  /**
   * DOCU: Get Current Scroll Height
   * @returns {number}
   */
  static getCurrentScrollHeight() {
    return $(window).scrollTop();
  }

  /**
   * DOCU: Get Current Screen Width
   * @returns {number}
   */
  static getScreenWidth() {
    return $(window).width();
  }

  /**
   * DOCU: Get Announcement Bar Height
   * @returns {number}
   */
  static getAnnouncementBarHeight() {
    return $('#announcement_bar').outerHeight();
  }

  /**
   * DOCU: Get Navigation Bar Height
   * @returns {number}
   */
  static getNavigationBarHeight() {
    const ANNOUNCEMENT_BAR_HEIGHT = $('#announcement_bar').outerHeight();
    const MAIN_NAVIGATION_BAR_HEIGHT = $('nav').outerHeight();

    return MAIN_NAVIGATION_BAR_HEIGHT + ANNOUNCEMENT_BAR_HEIGHT;
  }

  /**
   * DOCU: On Hover Element with Title, Add Title Text 
   */  
  onHoverTitle() {
    $('[title]').hover(function(e){ // Mouse Over
      const TITLE_TEXT = $(this).attr('title');
      
      $(this).data('tiptext', TITLE_TEXT).removeAttr('title');
      $('<p class="tooltip"></p>').text(TITLE_TEXT).appendTo('body').fadeIn(300);
    }, function(){ // Mouse Out
      $(this).attr('title', $(this).data('tiptext'));
      $('.tooltip').remove();
    }).mousemove(function(e){ // Mouse Over the Text 
      $('.tooltip').css('top', (e.pageY + 20) + 'px').css('left', (e.pageX + 10) + 'px');
    });
  }

  /**
   * DOCU: Get Current Currency
   * @returns {string}
   */
  static getCurrency() {
    return $('#cart_total_price').text()[0];
  }

  /**
   * DOCU: Initialize Buffer Timer 
   */
  initBuffer() {
		HEAD_CONTROLLER.navigation_bar.current_height = $(window).scrollTop();
		$('#loading_mask, #loading_animation').show();

		this.is_buffer_open = true;
		clearTimeout(this.buffer_timer);
		
		this.buffer_timer = setTimeout(() => { 
      this.is_buffer_open = false;
      $('#loading_mask, #loading_animation').hide();
		}, 5000);
	}


  /**
   * DOCU: On Create Item Create Confirmation Box Item, hide after 5s
   */
  onCreateConfirmationBoxItem() {
    const confirmationBox = $('#confirmation_box');

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.matches('.item[attached="false"]')) {
              $(node).attr('attached', 'true').delay(5000).hide(600);
            }
          });
        }
      });
    });
    
    observer.observe(confirmationBox[0], { childList: true });

    // $('#confirmation_box').on('DOMNodeInserted', '#giftwraploading', function(item){
    //   $(item.target).attr('attached', 'true').delay(6000).hide(600);
    // });
  }

  /**
   * DOCU: On Confirmation Box Clicked, hide
   */
  onConfirmationBoxClicked() {
    $(document).on('click', '#confirmation_box .item', function(e) {
      $('#confirmation_box .item').css("display", "none");
    });
  }

  /**
   * DOCU: On Skin Quiz is Opened, Hide GameBall
   */
  onSkinQuizClicked() {
    $('a[href="#quiz-ogHEKO"]').on('click', function() {
      $('#btnIframe').css('display', 'none!important');
    });

    $('a[href="#quiz-ogHEKO"] > span').on('click', function() {
      $('#btnIframe').css('display', 'block!important');
    });
  }

  /**
   * DOCU: On Geolocation Initialized, Cut and Insert on Navigation Bar
   */
  onCreateGeoLocation() {
    $('body').on('DOMNodeInserted', '.locale-selectors__container', function () {
      $('#currency_selector_container').html($('form[action="/localization"]'));
      $('form[action="/localization"] select').removeClass("locale-selectors__selector");
      // Trim Down String
      $('#currency_selector_container').find('option').each(function() {
        const INDEX = $(this).text().indexOf("(") + 1;
        const TEXT = $(this).text().slice(INDEX, -2);
        $(this).text(TEXT);
      });
    });
  }

  /**
   * DOCU: Initialize Sal Animation
   */
  initSal() {
    const SCROLL_ANIMATIONS = sal({ threshold: 0.1 });

    if(screen.width < 768) {
      SCROLL_ANIMATIONS.disable();
    }

    addEventListener("resize", () => {
      if(screen.width < 768) {
        SCROLL_ANIMATIONS.disable();
      } else {
        SCROLL_ANIMATIONS.enable();
      }
    });
  }

  /**
   * DOCU: Validate Email Address
   */
  static isValidEmail(email) {
    const emailFilter = /^([a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$/;

    return (emailFilter.test(email)) ? true : false;
  }

  /**
   * DOCU: on Successfull Newsletter Subscription, Display Confirmation Message
   */
  onSuccessfullNewsletter() {
    const URL_PARAMS = new URLSearchParams(window.location.search);
    const NEW_URL = location.href.split("?")[0];

    if(URL_PARAMS.get('customer_posted')) {
      HEAD_CONTROLLER.analytics.sendLeadCreated('newsletter'); 
      $('#confirmation_box').prepend(`<div class="item" attached="false"><p><strong> 🎉 Congratulations! </strong> you have successfully <strong>Subscribed</strong> to our newsletter!🎉</br></p> </div>`);
      window.history.pushState('object', document.title, NEW_URL);
    }
  }

  /**
   * DOCU: on Successfull Account Registration Subscription, Display Confirmation Message
   */
  onSuccessfullRegistration() { 
    const URL_PARAMS = new URLSearchParams(window.location.search);
    const NEW_URL = location.href.split("?")[0];

    if(!$('#gameball-customerID').val() && URL_PARAMS.get('new_registered')) {
      window.location.replace('/account/login/?forgot_password=true#recover');
    } else if(URL_PARAMS.get('new_registered')) {
      HEAD_CONTROLLER.analytics.sendLeadCreated('register');      
      $('#confirmation_box').prepend(`<div class="item" attached="false"><p><strong> 🎉 Congratulations! </strong> you have successfully <strong>registered</strong> an account!🎉 </p></div>`);
      window.history.pushState('object', document.title, NEW_URL);
    }

    if(URL_PARAMS.get('forgot_password')) {
      $('#confirmation_box').prepend(`<div class="item" attached="false"><p>⚠️ <strong>You already have an account</strong> associated with your email, If you forget the password please <strong>reset</strong> it! ⚠️</p></div>`);
    }
  }

  static getStarReviews(product) {
    let star_reviews = '';

    if(+product.rating > 0) {
      star_reviews = `<div class="judge_me_star_reviews"> <span class="jdgm-prev-badge__stars" data-score="4.00" tabindex="0" aria-label="4.00 stars" role="button">`;
      let counter = 0;

      for(let i = 0; i < Math.floor(+product.rating); i++) {
        star_reviews += '<span class="jdgm-star jdgm--on"></span>';
        counter++;
      }

      if(Math.ceil(product.rating - counter )) {
        star_reviews += '<span class="jdgm-star jdgm--half"></span>';
        counter++;
      }

      if(counter != 5) {
        for(let i = 0; i < (5 - counter); i++) {
          star_reviews += '<span class="jdgm-star jdgm--off"></span>'
        }
      }
      
      star_reviews += `</span><span class="jdgm-prev-badge__text" style="margin-left: 5px"> ${ +product.rating_count } reviews</span></div>`;
    }

    return star_reviews;
  }

  // onDetectCountry() {
  //   if(Functions.getCookie("closed")) {
  //     return;
  //   } else if(Functions.getCookie("country") === "PH") {
  //     return;
  //   }
    
  //   if((Intl.DateTimeFormat().resolvedOptions().timeZone !== "Asia/Manila") && (Intl.DateTimeFormat().resolvedOptions().timeZone !== "Asia/Taipei")) {
  //     Functions.setCookie("country", "GB", 365);
  //     $('#loading_mask').show();
  //     $('#currency_popup').show();
  //   } else {
  //     Functions.setCookie("country", "PH", 365);
  //   }
    
  //   $('#currency_popup .close_button').click(() => {
  //     $('#loading_mask').hide();
  //     $('#currency_popup').hide();
  //     Functions.setCookie("closed", "true", 365);
  //   });
  // }

  async onDetectCountry() {
    if(Functions.getCookie("closed")) {
      return;
    } else if(Functions.getCookie("country") == "PH") {
      return;
    }

    if(!Functions.getCookie("region") || !Functions.getCookie("country")) {
      await $.get('https://ipinfo.io?token=e0aeaa1a700bbb', (data) => {
        Functions.setCookie("country", data.country, 365);
        Functions.setCookie("region", data.region, 365);
      });
    }

    // if(Functions.getCookie("country") != "PH") {
    //   Functions.setCookie("coupon_closed", 1, 1);
    //   $('#loading_mask').show();
    //   $('#currency_popup').show();
    // }

    // try {
    //   $.get('https://ipinfo.io?token=e0aeaa1a700bbb', (data) => {
    //     try {
    //       if(data.country != "PH") {
    //         Functions.setCookie("country", "GB", 365);
    //         $('#loading_mask').show();
    //         $('#currency_popup').show();
    //       } else {
    //         Functions.setCookie("country", "PH", 365);
    //       }  
    //     } catch(e) {
    //       if((Intl.DateTimeFormat().resolvedOptions().timeZone !== "Asia/Manila") && (Intl.DateTimeFormat().resolvedOptions().timeZone !== "Asia/Taipei")) {
    //         Functions.setCookie("country", "GB", 365);
    //         $('#loading_mask').show();
    //         $('#currency_popup').show();
    //       } else {
    //         Functions.setCookie("country", "PH", 365);
    //       }
    //     }
    //   });
    // } catch(e) {
      // if((Intl.DateTimeFormat().resolvedOptions().timeZone !== "Asia/Manila") && (Intl.DateTimeFormat().resolvedOptions().timeZone !== "Asia/Taipei")) {
      //   Functions.setCookie("country", "GB", 365);
      //   $('#loading_mask').show();
      //   $('#currency_popup').show();
      // } else {
      //   Functions.setCookie("country", "PH", 365);
      // }
    // }

    // $('#currency_popup .close_button').click(() => {
    //   $('#loading_mask').hide();
    //   $('#currency_popup').hide();
    //   Functions.setCookie("closed", "true", 365);
    // });
  }

    /**
   * DOCU: Set Cookie
   * @param {string} key
   * @param {any} value
   * @param {int} days_to_live
   */
    static setCookie(key, value, days_to_live) {
      let cookie = key + "=" + encodeURIComponent(value);
      
      if(typeof days_to_live === "number") {
        cookie += "; max-age=" + (days_to_live * 24 * 60 * 60);
        document.cookie = cookie + "; path=/";
      }
    }
  
    /**
     * DOCU: Get Cookie
     * @param {string} key
     * @return {any}
     */
    static getCookie(key) {
      let cookieArr = document.cookie.split(";");
      
      for(let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");
  
        if(key == cookiePair[0].trim()) {
          return decodeURIComponent(cookiePair[1]);
        }
      }
      
      return 0;
    }

  initFloatingCoupon() {
    const floating_coupon = document.getElementById("floating_discount");
    let oldPositionX =  floating_coupon.style.left;
    let oldPositionY = floating_coupon.style.top;
    let xPixels = 0;
    let yPixels = 0;
    let timer = 0;

    const move = (e) => {      
      floating_coupon.style.animation = "initial";
      if (!floating_coupon.classList.contains("fab-active")) {
        if (e.type === "touchmove") {
          floating_coupon.style.top = (e.touches[0].clientY - yPixels) + "px";
          floating_coupon.style.left = (e.touches[0].clientX - xPixels) + "px";
        } else {
          floating_coupon.style.top = (e.clientY - yPixels) + "px";
          floating_coupon.style.left = (e.clientX - xPixels) + "px";
        }
      }
    };

    const mouseDown = (e) => {    
      console.log(((!e.clientY) ? e.touches[0].clientY : e.clientY));

      oldPositionY = floating_coupon.style.top;
      oldPositionX = floating_coupon.style.left;

      xPixels = ((!e.clientX) ? e.touches[0].clientX : e.clientX) - floating_coupon.getBoundingClientRect().left;
      yPixels = ((!e.clientY) ? e.touches[0].clientY : e.clientY) - floating_coupon.getBoundingClientRect().top;

      if (e.type === "mousedown") {
        window.addEventListener("mousemove", move);
      } else {
        window.addEventListener("touchmove", move);
      }

      floating_coupon.style.transition = "none";
    };

    // setTimeout(() => {
    //   if(!Functions.getCookie("coupon_closed")) {
    //     floating_coupon.classList.toggle("fab-active");
    //     $('#loading_mask').show();
    //     $("#newsletter_popup").css("display", "flex");
    //   }
    // }, 4000);

    // const mouseUp = (e) => {
    //   timer = 0;
    //   setTimeout(() => {
    //     timer = 1
    //   }, 500);

    //   if(oldPositionY === floating_coupon.style.top && oldPositionX === floating_coupon.style.left) {
    //     floating_coupon.classList.toggle("fab-active");
    //     $('#loading_mask').show();
    //     $("#newsletter_popup").css("display", "flex");
    //   }

    //   if (e.type === "mouseup") {
    //     window.removeEventListener("mousemove", move);
    //   } else {
    //     window.removeEventListener("touchmove", move);
    //   }

    //   snapToSide(e);
    //   floating_coupon.style.transition = "0.3s ease-in-out left";
    // };

    // const snapToSide = (e) => {
    //   const wrapperElement = document.getElementsByTagName("BODY")[0];
    //   const WINDOW_WIDTH = window.innerWidth;
    //   let currPositionX, currPositionY;

    //   if (e.type === "touchend") {
    //     currPositionX = e.changedTouches[0].clientX;
    //     currPositionY = e.changedTouches[0].clientY;
    //   } else {
    //     currPositionX = e.clientX;
    //     currPositionY = e.clientY;
    //   }

    //   if(currPositionY < 50) {
    //     floating_coupon.style.top = 0 + "px"; 
    //   }

    //   if(currPositionY > wrapperElement.clientHeight - 50) {
    //     floating_coupon.style.top = (wrapperElement.clientHeight - 50) + "px"; 
    //   }

    //   if (currPositionX < (WINDOW_WIDTH / 2)) {
    //     floating_coupon.style.left = 0 + "px";
    //     floating_coupon.classList.remove('right');
    //     floating_coupon.classList.add('left');
    //   } else {
    //     floating_coupon.style.left = Math.round(WINDOW_WIDTH - $('#floating_discount').width()) + "px";
    //     floating_coupon.classList.remove('left');
    //     floating_coupon.classList.add('right');
    //   }

    //   Functions.setCookie("discount_tab_position", JSON.stringify({top: floating_coupon.style.top, left: floating_coupon.style.left, myclass: floating_coupon.classList[0]}), 1);
    //   // floating_coupon.style.left = 0 + "px";
    //   // floating_coupon.classList.add('left');
    // };

    // floating_coupon.addEventListener("mousedown", mouseDown);
    // floating_coupon.addEventListener("mouseup", mouseUp);
    // floating_coupon.addEventListener("touchstart", mouseDown);
    // floating_coupon.addEventListener("touchend", mouseUp);
    
    // $("#newsletter_popup .close_button").click(() => {
    //   $('#loading_mask').hide();
    //   $("#newsletter_popup").hide();
    //   floating_coupon.classList.toggle("fab-active");
    //   Functions.setCookie("coupon_closed", 1, 1);
    // });

    // $("#loading_mask, #newsletter_popup .text_box > p > a").click(() => {
    //   if(timer) {
    //     $("#newsletter_popup").hide();
    //     $("#loading_mask").hide();
    //     floating_coupon.classList.remove("fab-active");
    //   }
    // });

    // $('#newsletter_popup #copy_to_clipboard').click(() => {
    //   var copyText = document.getElementById("newbie_code");
    //   navigator.clipboard.writeText(copyText.innerText);
    //   var tooltip = document.getElementById("myTooltip");
    //   tooltip.innerHTML = "Copied: " + copyText.innerText;
    // });

    // $('#newsletter_popup #copy_to_clipboard').on("mouseout", () => {
    //   var tooltip = document.getElementById("myTooltip");
    //   tooltip.innerHTML = "Copy to clipboard";
    // });
  }

  /**
   * DOCU: On Banner Click
   */
  onBannerClick() {
    $(document).on("click", "a", (e) => {
      if(!($(e.target).closest("a").attr("campaign"))) { return }
      HEAD_CONTROLLER.analytics.sendClickBanner($(e.target).closest("a").attr("campaign"));
    });
  }

  /**
   * DOCU: Applies Discount Code
   */
  static applyDiscountCode(discount_code) {
    $.get(`https://thecollective.ph/discount/${discount_code}`, (data) => {
      $.post('/cart', (e) => {
        HEAD_CONTROLLER.cart.updateCartSection(e); 
        HEAD_CONTROLLER.cart.updateNavCart(e); 
      });
    });
  }
  
  /**
   * DOCU: Remove Discount Code
   */
  static removeDiscountCode() {
    $.get(`https://thecollective.ph/discount/undefined`, (data) => {
      $.post('/cart', (e) => {
        HEAD_CONTROLLER.cart.updateCartSection(e); 
        HEAD_CONTROLLER.cart.updateNavCart(e); 
      });
    });
  }

  /**
   * DOCU: Apply Discount code via URL
   */
  onRedirectWithDiscount() {
    const URL_PARAMS = new URLSearchParams(window.location.search);
    if(!URL_PARAMS.get('discount')) { return }

    Functions.applyDiscountCode(URL_PARAMS.get('discount'));
  }
  
  // /**
  //  * DOCU: Apply Discount code via URL
  //  */
  // onSubmitDiscountCode() {
  //   $('#discount_code').text();
  // }

  /**
   * DOCU: Initializes JoyAI Chatbot
   */
  initJoyAI() {
    $("#joyai_floating").show();
    setInterval(() => {
      sessionStorage.setItem("message_counter", "0");
    }, 60000);
    
    // const disabledInput = document.getElementById("joyai_input_field");
    // disabledInput.addEventListener("click", () => {
    //   if (disabledInput.readOnly) {
    //     window.location.href = "/account/login?source=joyai";
    //   }
    // });
  }


  onToggleJoyAI() {
    if(!sessionStorage.getItem("joy_status")) {
      sessionStorage.setItem("joy_status", "closed");
      $("#joyai_button").attr("toggle-active", "0");
    }

    $(document).on('click', "#joyai_button, #joyai_floating .chat_container .top", () => {
      if(!+$("#joyai_button").attr("toggle-active")) {
        this.current_height = Functions.getCurrentScrollHeight();
        $("#joyai_floating .chat_container").css("display", "block");
        $("#joyai_button").attr("toggle-active", "1");
        document.querySelectorAll(`#joyai_floating input[type="text"]`)[0].focus();
        const scroll = $("#joyai_floating .middle");
        scroll.animate({scrollTop: scroll.prop("scrollHeight")});
        sessionStorage.setItem("joy_status", "open");
        $("#joyai_floating > .bubble").css("display", "none");
        if(HEAD_CONTROLLER.navigation_bar.current_device != 'desktop') {
          $('body').css("overflow-y", "hidden").css("position", "fixed").css("top", `-${ this.current_height }px`);
        }
      } else {
        $("#joyai_floating .chat_container").css("display", "none");
        $("#joyai_button").attr("toggle-active", "0");
        sessionStorage.setItem("joy_status", "closed");
        if(HEAD_CONTROLLER.navigation_bar.current_device != 'desktop') {
          $('body').css("overflow-y", "initial").css("position", "initial").css("top", `0px`);
          $('html').scrollTop( this.current_height );
        }
      }
    })

    $("#joyai_floating > .bubble").click(() => { $("#joyai_floating > .bubble").css("display", "none") }); 
  }

  onAskQuestion() {
    let history = [];
    let customer_id = $("#gameball-customerID").val();
    if(customer_id) {
      $.post(`/apps/api-47/joyai/history/${ customer_id }`, data => {
        if(sessionStorage.getItem("joyai")) {
          history = JSON.parse(sessionStorage.getItem("joyai")).data;
        }

        if(history.length) {
          if(history[history.length - 1].role == "user") {
            Functions.sendMessage(history);
            Functions.updateJoyAI(history);
            sessionStorage.setItem("joyai", JSON.stringify({data: history}));

            $("#joyai_floating .middle").append(`
              <div class="model">
                <div class="bubble">
                  <div class="dot_animation_loader"></div>
                </div>
              </div>
            `);

          } else if(data.data) {
            history = data.data;
            sessionStorage.setItem("joyai", JSON.stringify({data: history}));
            Functions.updateJoyAI(history);
          } else {
            sessionStorage.setItem("joyai", JSON.stringify({data: [{role: "model", parts: [{"text": `<p>Hey ${ $("#joy_user_name").val() }!👋<br />I'm Joy from The Collective, <br />how may I help you today?</p>`}]}]}));
            history = JSON.parse(sessionStorage.getItem("joyai")).data;
            
            $("#joyai_floating > .bubble").html(`<p>Hey ${ $("#joy_user_name").val() }!👋<br />I'm Joy from The Collective, <br />how may I help you today?</p>`).show();
            Functions.updateJoyAI(history);
          }
        } else {
          sessionStorage.setItem("joyai", JSON.stringify({data: [{role: "model", parts: [{"text": `<p>Hey ${ $("#joy_user_name").val() }!👋<br />I'm Joy from The Collective, <br />how may I help you today?</p>`}]}]}));
          history = JSON.parse(sessionStorage.getItem("joyai")).data;
          Functions.updateJoyAI(history);
        }
      });
    } else if(!sessionStorage.getItem("joyai") && !customer_id) {
        sessionStorage.setItem("joyai", JSON.stringify({data: [{role: "model", parts: [{"text": `<p>Hey there!👋<br />I'm Joy from The Collective, <br />how may I help you today?<span style="display: block; font-size:10px; color: var(--color-gray)">Average response time: 30s</span></p>`}]}]}));
        history = JSON.parse(sessionStorage.getItem("joyai")).data;

        $("#joyai_floating > .bubble").html(`<p>Hey there!👋<br />I'm Joy from The Collective, <br />how may I help you today?<span style="display: block; font-size:10px; color: var(--color-gray)">Average response time: 30s</span></p>`).show();

        Functions.updateJoyAI(history);

    } else {
      history = JSON.parse(sessionStorage.getItem("joyai")).data;
      Functions.updateJoyAI(history);

      if(history[history.length - 1].role == "user") {
        $("#joyai_floating .middle").append(`
          <div class="model">
            <div class="bubble">
              <div class="dot_animation_loader"></div>
            </div>
          </div>
        `);

        Functions.sendMessage(history);
      }
    }

 
    $(document).on("click", ".quick_questions", (e) => {
      let question = $(e.target).attr("value");
      history.push({role: "user", parts: [{"text": "<p>" + question + "</p>"}]});
      let answer = "";
      if(question.includes("🛵")) {
        answer = `
          <p>The estimated shipping time for standard deliveries is:</p><br>
            <ul>
              <li>NCR: Same Day or 1-2 Days </li>
              <li>Luzon & Visayas: 3-5 Days</li>
              <li>Mindanao: 5-7 Days</li>
            </ul><br>
          <p>These are shipping times are estimated. 🚚</p>
        `;
      } else if (question.includes("📦")) {
        answer = `
          <p>We want you to have an enjoyable purchasing experience, so we have flat rates for all our delivery methods:</p>
              <ul>
                <li>Same day delivery within Metro Manila: PHP 200.00</li>
                <li>Nationwide shipping: PHP 245.00</li>
              </ul>
          <p>We also offer FREE Nationwide Shipping! for orders PHP 3,500.00 and up ✈️</p> 
        `;
      } else if (question.includes("💳")) {
        answer = `
          <p>We accept payments through the following methods:</p>
                <ul>
                  <li>E-wallets (GCash, Maya, Paypal, GrabPay)</li>
                  <li>Credit card (Mastercard, Visa)</li>
                  <li>Manual bank deposit</li>
                  <li>And more!, please head over to checkout page to see whats available payment option we have for you!.</li>
                </ul>
          <p>If you'd like to send your payment through a different method, just let us know and we'd be happy to help! 😊</p>
        `;
      } else if (question.includes("☎️")) {
        answer = `
            <p>We have a dedicated AI Assistant that can answer most of your concerns, including product, product ingredient, skincare routine, about The Collective and many more!</p>
              <p>Simply Log in to your <a href="/account">Account</a> and start asking your concerns.</p>
              <p>Our team will also review your conversation and will help you address your concerns as soon as possible.</p>
              <br>
              <p>If you'd like to speak to our real agent 😊<br />You can reach out to us at:</p>
              <ul>
                <li>Email: we@thecollective.ph</li>
                <li>Phone: 09457287754</li>
                <li>Instagram: <a href="https://www.instagram.com/thecollective">Click Here</a></li>
                <li>Available from Mondays to Fridays 8am to 5pm</li>
              </ul>
            <p>They'll be happy to assist you further.</p>
        `;
      }

      $("#joyai_floating .middle").append(`
        <div class="model">
          <div class="bubble">
            ${ answer }
          </div>
        </div>
      `);
      history.push({role: "model", parts: [{"text": answer}]});
      sessionStorage.setItem("joyai", JSON.stringify({data: history}));
      Functions.updateJoyAI(history);

      // $(`#joyai_floating input[type="text"]`).val("");
      // $(`#joyai_floating #quick_questions`).hide();
      // let history = JSON.parse(sessionStorage.getItem("joyai")).data;
      // history.push({role: "user", parts: [{"text": "<p>" +  $(e.target).attr("value") + "</p>"}]});
      // sessionStorage.setItem("joyai", JSON.stringify({data: history}));
      // Functions.updateJoyAI(history);
      // $("#joyai_floating .middle").append(`
      //   <div class="model">
      //     <div class="bubble">
      //       <div class="dot_animation_loader"></div>
      //     </div>
      //   </div>
      // `);

      // Functions.sendMessage(history);
    });

    $(document).on('click', '#joyai_floating input[type="submit"]', () => {
      let question = $(`#joyai_floating input[type="text"]`).val();
      if(!question) return;
      $(`#joyai_floating input[type="text"]`).val("").attr("readonly", "1");
      $(`#joyai_floating #quick_questions`).hide();

      let history = JSON.parse(sessionStorage.getItem("joyai")).data;
      history.push({role: "user", parts: [{"text": "<p>" + question + "</p>"}]});
      sessionStorage.setItem("joyai", JSON.stringify({data: history}));
      Functions.updateJoyAI(history);
      $("#joyai_floating .middle").append(`
        <div class="model">
          <div class="bubble">
            <div class="dot_animation_loader"></div>
          </div>
        </div>
      `);

      Functions.sendMessage(history);
    });

    $(document).keyup(function(event) {
      if ($(`#joyai_floating input[type="text"]`).is(":focus") && event.key == "Enter") {
        let question = $(`#joyai_floating input[type="text"]`).val();
        if(!question) return;
        $(`#joyai_floating input[type="text"]`).val("").attr("readonly", "1");
        $(`#joyai_floating #quick_questions`).hide();

        let history = JSON.parse(sessionStorage.getItem("joyai")).data;
        history.push({role: "user", parts: [{"text": "<p>" + question + "</p>"}]});
        sessionStorage.setItem("joyai", JSON.stringify({data: history}));
        Functions.updateJoyAI(history);
        $("#joyai_floating .middle").append(`
          <div class="model">
            <div class="bubble">
              <div class="dot_animation_loader"></div>
            </div>
          </div>
        `);

        Functions.sendMessage(history);
      }
    });

  }

  static sendMessage(history) {
    let customer_id = $("#gameball-customerID").val();
    if (+sessionStorage.getItem("message_counter") + 1 >= 10) {
      sessionStorage.setItem("joy_status", "open");
      history.push({role: "model", parts: [{"text": "<p>Your sending too many messages. please try after few minutes</p>"}]});
      sessionStorage.setItem("joyai", JSON.stringify({data: history}));
      Functions.updateJoyAI(history);
      // if(customer_id) {
        // }
      $(`#joyai_floating input[type="text"]`).removeAttr("readonly");
      $(`#joyai_floating #quick_questions`).show();
      document.querySelectorAll(`#joyai_floating input[type="text"]`)[0].focus();
    }
    let joy_user_data = $("#joy_user_data").val();
    let customer_name = $("#joy_user_name").val();
    let customer_data = undefined;
    if(joy_user_data) {
      customer_data = {id: customer_id, name: customer_name, info: {role: "user", parts: [{"text": `<p>Name: ${ customer_name }, ${ joy_user_data }</p>`}]}};
    }

    $.post("/apps/api-47/joyai", {"data": history, "customer": customer_data })
      .done((data) => {
        sessionStorage.setItem("message_counter", (+sessionStorage.getItem("message_counter") + 1));
        sessionStorage.setItem("joy_status", "open");
        history.push({role: "model", parts: [{"text": data.data}]});
        sessionStorage.setItem("joyai", JSON.stringify({data: history}));
        Functions.updateJoyAI(history);
        // if(customer_id) {
        $(`#joyai_floating input[type="text"]`).removeAttr("readonly");
        // }
        $(`#joyai_floating #quick_questions`).show();
        document.querySelectorAll(`#joyai_floating input[type="text"]`)[0].focus();
      })
      .fail((data) => {
        sessionStorage.setItem("message_counter", (+sessionStorage.getItem("message_counter") + 1));
        $("#joyai_floating .middle").append(`
          <div class="model">
            <div class="bubble">
              <p>One moment please.</p>
            </div>
          </div>
        `);
        setTimeout(() => {
          Functions.sendMessage(history);
        }, 60000);
      });
  }
  
  static updateJoyAI(history) {
    let html = "";
    for(let i = 0; i < history.length; i++) {
      
      html += `
        <div class="${ history[i].role }">
          <div class="bubble">
            ${ history[i].parts[0].text }
          </div>
        </div>
      `;
    }

    if(!+$("#joyai_button").attr("toggle-active") && sessionStorage.getItem("joy_status") == "open") {
      $("#joyai_floating .chat_container").css("display", "block");
      $("#joyai_button").attr("toggle-active", "1");
      if(HEAD_CONTROLLER.navigation_bar.current_device != 'desktop') {
        $('body').css("overflow-y", "hidden").css("position", "fixed").css("top", `-${ this.current_height }px`);
      }
    }

    $("#joyai_floating .middle").html(html);
    const scroll = $("#joyai_floating .middle");
    scroll.animate({scrollTop: scroll.prop("scrollHeight")});
  }

  /**
   * DOCU: On Cookie Consent Loaded, Close after 5 seconds 
   */
  onCookieConsentLoaded() {
    setTimeout(() => {
      if($(".spopupbtnok")[0]) {
        $(".spopupbtnok")[0].click();
      }
    }, 8000);
  }


  static sendTrivia(question) {
    $.post("/apps/api-47/joyai", {"data": [{role: "user", parts: [{"text": question}]}], "customer": undefined })
      .done((data) => {
        const regex = /\bSomething went wrong\b/;
        const match = data.data.match(regex);
        const regex2 = /\bsorry\b/;
        const match2 = data.data.match(regex);
        if (!match || !match2) {
          if(!Functions.getCookie("trivia")) {
            data.data += `
              <p style="border-top: 1px solid white; padding-top: 10px">Do you like more Trivia?</p>
              <span class="trivia_class" style="background-color: var(--color-green)" value="active">Yes</span> | <span class="trivia_class" style="background-color: var(--color-yellow); color: black" value="reduced">Not Really</span> | <span class="trivia_class" style="background-color: var(--color-red)" value="remove">No</span>
            `;
          }
          $("#joyai_floating > .bubble").html(data.data).show();

          $(".trivia_class").click((e) => {
            Functions.setCookie("trivia", $(e.target).attr("value"), 365);
          })
        }
      })
      .fail((data) => {
        // Problem
      });
  }

}